import styled from '@emotion/styled';

export const Title = styled.text`
font-size: 32px;
font-weight: bold;
position: relative;
top: 48px;
  margin-left: 42px;
`;
export const CardsWrapper = styled.div`
  margin: 24px 32px;
`;
export const CardRow = styled.div`
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-evenly;
margin-top: 24px;`;
